import { Lock, Unlock } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { useActiveSeason } from '@/lib/season/SeasonContext';

/**
 * Toggle 🔓 / 🔒 рядом с SeasonPicker.
 * Виден только для неактивных сезонов.
 */
export function SeasonEditUnlockToggle() {
  const { season, setEditUnlock } = useActiveSeason();
  if (!season || season.isCurrent) return null;

  const unlocked = season.editUnlock;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="sm"
          variant={unlocked ? 'destructive' : 'outline'}
          onClick={() => setEditUnlock(!unlocked)}
          className="gap-1.5"
        >
          {unlocked ? (
            <Unlock className="h-3.5 w-3.5" />
          ) : (
            <Lock className="h-3.5 w-3.5" />
          )}
          <span>{unlocked ? 'Редактирование' : 'Только чтение'}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        {unlocked
          ? `Сезон ${season.year} разблокирован для редактирования — даты новых записей по умолчанию = ${season.asOfDate}`
          : `Разблокировать редактирование сезона ${season.year}`}
      </TooltipContent>
    </Tooltip>
  );
}

export default SeasonEditUnlockToggle;
